export default "__VITE_ASSET__BYAEzztv__"